const statements = [
  '提交为工具直连提交+回执回传，不承诺放行/审批/退税结果',
  'A类产品零人工介入；校验不通过退回补齐后重提',
  '服务包为叠加项，不替代订阅费/免税费用',
  '留存策略以产品版本与合同约定为准',
];

export default function BoundaryStatement() {
  return (
    <section className="py-12 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="bg-gray-100 border border-gray-200 rounded-2xl p-8">
          <div className="flex items-start gap-4">
            <div className="w-6 h-6 flex items-center justify-center rounded-full bg-gray-300 text-gray-600 flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-sm"></i>
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-bold text-gray-700 mb-3">边界与声明</h4>
              <ul className="space-y-2">
                {statements.map((statement, idx) => (
                  <li key={idx} className="text-sm text-gray-600 leading-relaxed">
                    • {statement}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}